const RADIAN = Math.PI / 180;

export const CustomLabel: React.FC = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: any) => {
  const radiusLabel = 20 + innerRadius + (outerRadius - innerRadius);
  const xLabel = cx + radiusLabel * Math.cos(-midAngle * RADIAN);
  const yLabel = cy + radiusLabel * Math.sin(-midAngle * RADIAN);
  return (
    <>
      <text
        x={xLabel}
        y={yLabel}
        fill={"black"}
        textAnchor={xLabel > cx ? "start" : "end"}
        dominantBaseline={"central"}
      >
        {percent === 1 ? "100%" : `${(percent * 100).toFixed(2)}%`}
      </text>
    </>
  );
};
